import useTranslation from "next-translate/useTranslation";
import { useState } from "react";
import Dropdown from "../DropDown/DropDown";
import classes from "./TypologieSelect.module.scss";

export default function TypologieSelect({
  onTypologieSelect,
  searchPayloadTypologie,
}: {
  onTypologieSelect: (typologie: number[]) => void;
  searchPayloadTypologie: any;
}) {
  const { t } = useTranslation("commonAnnonces");
  // const TYPOLOGIE_LIST = [
  //   { value: 0, label: t("Studio") },
  //   { value: 1, label: "1" },
  //   { value: 2, label: "2" },
  //   { value: 3, label: "3" },
  //   { value: 4, label: "4" },
  //   { value: 5, label: `${5} ${t("et plus")}` },
  // ];

  const [typologie, setTypologie] = useState(
    searchPayloadTypologie.map((item) => {
      return parseInt(item);
    })
  );
  const [dropdownToggle, setDropdownToggle] = useState(false);
  const typologieChangeHandler = (selectedTypologie: number) => {
    let updatedTypologie = [...typologie];
    if (!typologie.includes(selectedTypologie))
      updatedTypologie.push(selectedTypologie);
    else {
      updatedTypologie = typologie.filter((item) => item !== selectedTypologie);
    }
    setTypologie(updatedTypologie);
  };
  const dropdownContent = (
    <div className={classes.container}>
      <div className={classes.componentTitle}>
        <span className={classes.title}>{t("Chambres")}</span>
      </div>
      <div className={classes.titleAndRoomsContainer}>
        <div className={classes.roomsNumContainer}>
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <div key={i} className={classes.roomsNumInnerContainer}>
              <button
                className={`${classes["mobile--filtres--typologies"]} ${
                  typologie.includes(i)
                    ? classes["mobile--filtres--typologies--active"]
                    : ""
                }`}
                onClick={(e) => {
                  typologieChangeHandler(i);
                }}
              >
                <span>
                  {/* {i === 0 ? t("Studio") : `${i}${i === 5 ? "+" : ""}`} */}
                  {i === 0 ? "0" : `${i}${i === 5 ? "+" : ""}`}
                </span>
              </button>
            </div>
          ))}
        </div>
      </div>
      <div className={classes.validBtnWrapper}>
        <button
          className={classes.validBtn}
          onClick={() => {
            onTypologieSelect(typologie);
            setDropdownToggle(false);
          }}
        >
          {t("Valider")}
        </button>
      </div>
    </div>
  );

  return (
    // <FormControl>
    //   <Select
    //     sx={{ height: "40px" }}
    //     name="typologie"
    //     multiple
    //     open={displayInputChambres}
    //     onOpen={() => {
    //       setDisplayInputChambres(true);
    //     }}
    //     onClose={() => {
    //       setDisplayInputChambres(false);
    //     }}
    //     displayEmpty
    //     input={
    //       <OutlinedInput
    //         className="border"
    //         style={{
    //           borderRadius: 2,
    //           fontSize: "15px",
    //           height: "40px",
    //         }}
    //       />
    //     }
    //     renderValue={(selected) => {
    //       if (selected.length === 0) {
    //         return t("Chambres");
    //       } else {
    //         return selected.join(" - ");
    //       }
    //     }}
    //     value={typologie}
    //     onChange={(e) => setTypologie(e.target.value as number[])}
    //     error={false}
    //   >
    //     {TYPOLOGIE_LIST.map((item) => (
    //       <MenuItem value={item.value} key={item.value}>
    //         <Checkbox checked={typologie.includes(item.value)} />
    //         {item.label}
    //       </MenuItem>
    //     ))}
    //     <div className="filtre-prix-annonce-mobile-button-container">
    //       <button
    //         className="filtre-prix-annonce-mobile-button-container"
    //         onClick={() => {
    //           onTypologieSelect(typologie);
    //           setDisplayInputChambres(false);
    //         }}
    //       >
    //         {t("Valider")}
    //       </button>
    //     </div>
    //   </Select>
    // </FormControl>
    <Dropdown
      t={t}
      className={`${classes.buttonWrapper} ${
        typologie.length ? classes.btnWrapperActive : ""
      }`}
      liststyling={classes.styles}
      contentComponent={dropdownContent}
      valueComponent={
        <ul className={classes.valueComponentListContainer}>
          {typologie.length > 0
            ? typologie.map((item, idx) => {
                return (
                  <li key={idx}>
                    {typologie.length > 1 && idx !== 0 ? "-" : ""}
                    {item}
                  </li>
                );
              })
            : t("Chambres")}
        </ul>
      }
      toggleBtnStyle={classes.toggleBtnStyle}
      onToggleActive={classes.toggleBtnActive}
      dropdownToggle={dropdownToggle}
      setDropdownToggle={setDropdownToggle}
    />
  );
}
